<script lang="ts">
	import { Button, ButtonGroupV2, SidepanelContent } from '@Shelly/shelly-design-system/index';
	import { format } from 'svelte-i18n';

	import DeviceChartsLayer from 'src/components/Chart/LayerChart/DeviceChartsLayer.svelte';
	import { getDeviceChartsConfig } from 'src/helpers/statistics/config/device_chart_config';

	import EventLog from 'src/components/EventLog/EventLog.svelte';

	// Types
	import type { Device } from 'src/types/Device.ts';
	import type { ChartConfigInterface } from 'src/types/Chart';

	export let device: Device;
	export let openedEventTimestamp: number | null = null;
	export let activeHistoryButton: number | null = null;

	const deviceChartsConfig: ChartConfigInterface[] = getDeviceChartsConfig(device);
	$: hasCharts = deviceChartsConfig.length > 0;

	const handleButtonClick = (button: number) => {
		activeButton = button;
		if (button === 1) {
			localOpenedEventTimestamp = null;
		}
		if (button === 2) {
			localActiveHistoryButton = null;
		}
	};

	let activeButton: number = 1;
	let localOpenedEventTimestamp: number | null = null;
	let localActiveHistoryButton: number | null = null;

	$: if (openedEventTimestamp !== null && openedEventTimestamp !== undefined) {
		activeButton = 2;
		localOpenedEventTimestamp = openedEventTimestamp;
	}

	$: if (activeHistoryButton !== null && activeHistoryButton !== undefined) {
		activeButton = activeHistoryButton;
		localActiveHistoryButton = activeHistoryButton;
	}

	$: if (activeButton === 1 && localOpenedEventTimestamp !== null) {
		localOpenedEventTimestamp = null;
	}
</script>

{#if hasCharts}
	<!-- Show Statistics and Activity Log buttons if charts are available -->
	<SidepanelContent>
		<ButtonGroupV2
			aria-label="Button group filter"
			noWrap
			slot="staticTop"
			class="width-full mb-m"
			styleType="body-extra-small"
		>
			<Button
				class={`width-full ${activeButton === 1 && 'active'}`}
				size="m"
				on:click={() => handleButtonClick(1)}
			>
				{$format('statistics', { default: 'Statistics' })}
			</Button>
			<Button
				class={`width-full ${activeButton === 2 && 'active'}`}
				size="m"
				on:click={() => handleButtonClick(2)}
			>
				{$format('activity_log', { default: 'Activity Log' })}
			</Button>
		</ButtonGroupV2>

		{#if activeButton === 1}
			<DeviceChartsLayer {device} />
		{:else if activeButton === 2}
			<EventLog {device} type={'device'} openedEventTimestamp={localOpenedEventTimestamp} />
		{/if}
	</SidepanelContent>
{:else}
	<!-- Show only Activity Log if no charts are available -->
	<SidepanelContent>
		<EventLog {device} type={'device'} openedEventTimestamp={localOpenedEventTimestamp} />
	</SidepanelContent>
{/if}
